<template>
  <div class="fixed bottom-3 right-3">
    <div
      @click="form.open"
      class="cursor-pointer rounded-lg border bg-white px-4 py-2 shadow-md transition-all hover:border-pink-800 hover:bg-pink-800 hover:text-white hover:shadow-lg"
    >
      Ondersteuning
    </div>
  </div>
</template>

<script setup lang="ts">
  import * as Sentry from '@sentry/vue'

  const feedback = Sentry.feedbackIntegration({
    autoInject: false,
    colorScheme: 'light',
    buttonLabel: 'Ondersteuning',
    cancelButtonLabel: 'Annuleren',
    emailLabel: 'Je e-mailadres',
    emailPlaceholder: '',
    formTitle: 'Neem contact op',
    messageLabel: 'Beschrijving',
    messagePlaceholder: 'Stel hier je vraag, of beschrijf je probleem.',
    nameLabel: 'Je naam',
    isNameRequired: true,
    isEmailRequired: true,
    namePlaceholder: '',
    showBranding: false,
    submitButtonLabel: 'Insturen',
    successMessageText: 'Bedankt voor je bericht!',
    useSentryUser: { name: 'name', email: 'email' },
  })

  const form = await feedback.createForm()
  form.appendToDom()
</script>
